/* ExportDataVeilRenderer.js */

"use strict";
const _ = require("lodash");
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const ComboBoxControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single
    .ComboBox;
// const InputTextControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputText;
const InputRadioControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single
    .InputRadio;

class ExportDataVeilRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("exportdata-veil-gl"); //TODO Setup the root Element
        this._rootElem.component = this._model;
        if (this.model.darkTheme) {
            this._rootElem.classList.add("dark");
        }

        this._confirmButton = new ButtonControl({
            label: "Run",
            darkTheme: this.model.darkTheme,
        });

        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: this.model.darkTheme,
        });

        this._scheduleButton = new ButtonControl({
            label: "Schedule",
            darkTheme: this.model.darkTheme,
        });

        this._contentContainer = document.createElement("div");
        this._contentContainer.classList.add("dataexport-veil-content");

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model.titleText;

        this._deviceSel = new InputRadioControl({
            labelShown: true,
            horizontal: true,
        });

        const radioOpts = [
            {
                label: "Selected",
                value: "sel",
            },
        ];

        if (this._model._hasBasicSearch) {
            radioOpts.push({
                label: "Current search results",
                value: "cres",
            });
        } else {
            radioOpts.push({
                label: "Apply current filter",
                value: "filter",
            });
        }

        radioOpts.push({
            label: "All",
            value: "all",
        });

        this._deviceRadioOptions = {
            opts: radioOpts,
            value: "sel",
        };

        // this._fileNameInput = new InputTextControl({
        //     darkTheme: this.model.darkTheme,
        //     label: "something",
        //     value:
        //         "Explore data " +
        //         " - " +
        //         new Date().toLocaleDateString() +
        //         " " +
        //         new Date().toLocaleTimeString()
        // });

        this._templatesList = new ComboBoxControl({
            options: [],
            showFilter: true,
            disabled: false,
            darkTheme: this.model.darkTheme,
            label: this.model._templateSelLabel,
        });

        this._buttonContainer = document.createElement("button-container");

        this._msgComponent = document.createElement("msg");

        this._reportTypeSel = new InputRadioControl({
            labelShown: true,
            horizontal: true,
            options: [
                {
                    label: "CSV",
                    value: "csv",
                },
                {
                    label: "PDF",
                    value: "pdf",
                },
                {
                    label: "JSON",
                    value: "json",
                },
            ],
            value: "csv",
            label: "Report format",
        });

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._confirmButton.on(
            "UserClick",
            (this._onConfirmButtonClick = this._onConfirmButtonClick.bind(this))
        );
        this._cancelButton.on(
            "UserClick",
            (this._onCancelButtonClick = this._onCancelButtonClick.bind(this))
        );

        this._scheduleButton.on("UserClick", this._schedulePlanAction.bind(this));

        this._deviceSel.on(
            "UserValue",
            (this._onDeviceSelChange = this._onDeviceSelChange.bind(this))
        );
        this._reportTypeSel.on(
            "UserValue",
            (this._onReportTypeSelChange = this._onReportTypeSelChange.bind(this))
        );
        this._model.on("Msg", (this._onMessage = this._onMessage.bind(this)));
        this._templatesList.on(
            "UserValue",
            (this._onTemplateChange = this._onTemplateChange.bind(this))
        );
    }

    _unregisterListeners() {
        this._confirmButton.removeAllListeners("UserClick");
        this._cancelButton.removeAllListeners("UserClick");
        this._deviceSel.removeAllListeners("UserValue");
        this._reportTypeSel.removeAllListeners("UserValue");
        this._templatesList.removeAllListeners("UserValue");
        this._scheduleButton.removeListener("UserClick", this._schedulePlanAction);
    }

    _onConfirmButtonClick() {
        // let validationErrors = this._scheduleComponent.validateSchedule();
        // if (_.isEmpty(validationErrors)) {
        //     this._callSaveSchedule();
        // } else {
        //     let msg = "";
        //     validationErrors.forEach((validationMsg) => {
        //         msg += `<p>${validationMsg}</p>`;
        //     });
        //     this._msgComponent.innerHTML = msg;
        // }
        this._enableAllButtons(false);

        this._model.runTemplateWork(this._getWorkInput(), this._deviceSel.getValue());
    }

    _onCancelButtonClick() {
        this._callCancel();
    }

    _onSchedClick() {
        this._msgComponent.innerHTML = "";
    }

    _checkForImpliedConfirm(event) {
        if (event.keyCode === 13) {
            this._callStartCapture();
        }
    }

    _onDeviceSelChange(val) {
        // console.log(val);
        const activeView = this._model._gameEditor._activeView;
        switch (val) {
            case "all":
                this._model.devices = {};
                break;
            case "filter":
                this._model.devices = this._getFeedFilter();
                break;
            case "cres":
                // get ids on actions
                break;
            default:
                this._model.devices = activeView.selectedRows;
                break;
        }
        // console.log(this._model._devices);
    }

    _getFeedFilter() {
        const feedFilter = this._model._gameEditor._activeView._pagingDeviceFeed._filter;
        if (!_.isEmpty(feedFilter.$userQuery)) {
            return feedFilter.$userQuery;
        } else if (feedFilter.hasOwnProperty("$and") || feedFilter.hasOwnProperty("$or")) {
            return feedFilter;
        }
        return {};
    }

    _onReportTypeSelChange(val) {
        this._model.reportFormat = val;
    }

    _onMessage(msg) {
        this._msgComponent.innerHTML = msg;
    }
    _onTemplateChange(val) {
        this._model._selectedTemplate = val;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [
            this._confirmButton.shutdown(),
            this._cancelButton.shutdown(),
            this._reportTypeSel.shutdown(),
            this._deviceSel.shutdown(),
            // this._fileNameInput.shutdown(),
            this._templatesList.shutdown(),
        ];

        return Promise.all(promArr).then(
            () => {
                this._confirmButton = undefined;
                this._cancel = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._notificationsComponent = undefined;
                this._msgComponent = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._model = undefined;
                this._deviceRadioOptions = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "ExportDataVeilRenderer.shutdown() error");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve) => {
            if (!this._rootElem.hasChildNodes()) {
                return this._model.whenModelIsReady().then(() => {
                    if (this._model._templateEntities.length === 0) {
                        return this._model._context.reject({
                            errorMsg: "No templates available. Please create a template first.",
                            errorCode: "",
                        });
                    }

                    if (this._model._gameEditor._activeView.selectedRows.length <= 0) {
                        this._deviceRadioOptions.opts[0].disabled = true;
                        this._deviceRadioOptions.value = "all";
                    }
                    this._deviceSel.setOptions(this._deviceRadioOptions.opts);
                    this._deviceSel.setValue(this._deviceRadioOptions.value);
                    this._rootElem.appendChild(this._titleComponent);
                    this._rootElem.appendChild(this._contentContainer);
                    this._rootElem.appendChild(this._buttonContainer);
                    this._rootElem.appendChild(this._msgComponent);

                    // this._contentContainer.appendChild(this._createControlWithLabel(this._fileNameInput, this._model._fileNameLabel ));
                    this._contentContainer.appendChild(
                        this._createControlWithLabel(this._deviceSel, this._model._deviceSelLabel)
                    );
                    this._contentContainer.appendChild(
                        this._createControlWithLabel(
                            this._templatesList,
                            this._model._templateSelLabel
                        )
                    );
                    if (!this._model._isDE) {
                        this._contentContainer.appendChild(
                            this._createControlWithLabel(
                                this._reportTypeSel,
                                this._model._reportTypeSelLabel
                            )
                        );
                    }

                    this._templatesList.setOptions(
                        this._model._templateEntities.map((entity) => {
                            return {
                                label: entity.name,
                                value: entity,
                            };
                        })
                    );
                    this._templatesList.setValue(this._model._selectedTemplate);

                    this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                    this._buttonContainer.appendChild(this._scheduleButton.renderer.rootElement);
                    this._buttonContainer.appendChild(this._confirmButton.renderer.rootElement);
                    return Promise.resolve();
                });
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    _enableComfirmButtons(enable) {
        this._confirmButton.disabled = !enable;
    }

    _enableAllButtons(enable) {
        this._confirmButton.disabled = !enable;
        this._cancelButton.disabled = !enable;
        this._scheduleButton.disabled = !enable;
    }

    _createControlWithLabel(control, label = "") {
        const elem = document.createElement("div");
        elem.classList.add("control-inp");
        elem.classList.add(label.toLowerCase().replace(" ", "_").replace(/\W/g, ""), "label");
        const labelEl = document.createElement("label");
        labelEl.innerText = label;
        elem.appendChild(labelEl);
        elem.appendChild(control.renderer.rootElement);
        return elem;
    }

    _getWorkInput() {
        return {
            description:
                "Device Report - " +
                new Date().toLocaleDateString() +
                " " +
                new Date().toLocaleTimeString(),
        };
    }
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onValidationStateChanged(isValid) {
        this._enableComfirmButtons(isValid);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _callSaveSchedule() {
        this._model.saveSchedule();
    }

    _callCancel() {
        this._model.cancel({userRejected: true});
    }

    _schedulePlanAction() {
        const workInput = this._getWorkInput();
        return this._model.scheduleExport(workInput, this._deviceSel.getValue());
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = ExportDataVeilRenderer;
